class Drawer {
  constructor(triggerClass) {
    this.triggerClass = triggerClass;
    if ($("." + this.triggerClass).length > 0) {
      this.event();
    }
  }

  event() {
    $('.js-drawer-trigger').on('click', () => {
      $('html').toggleClass('is-drawer');
    });

    $('.js-link-close').on('click', () => {
      $('html').removeClass('is-drawer');
    });
  }
}
